export default __webpack_public_path__ + "static/media/undraw_processing_qj6a.b0b833ea.svg";